import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Flex, Box } from '@rebass/grid';
import ReactGA from 'react-ga';
import { H2 } from 'app/ui_components/tags';

import { isMobile } from 'app/helpers/utils';

import ReportItem from 'app/components/ReportItem';

import animate from 'app/helpers/animations/report';

class Report extends React.Component {
  static defaultProps = {
    shiftUp: 0,
  };

  static propTypes = {
    criteria: PropTypes.object.isRequired,
    shiftUp: PropTypes.number.isRequired,
    topFailed: PropTypes.array.isRequired,
  };

  componentDidMount() {
    ReactGA.pageview('Results');
    window.fbq && window.fbq('track', 'PageView');
    window.fbq && window.fbq('track', 'Lead');
    animate('.reportContainer');
  }

  render() {
    const { criteria, shiftUp, topFailed } = this.props;

    // The topmost Report Items should always be negative, so we're moving
    // the top improvment into the first index.
    const keys = Object.keys(criteria);
    const firstFailed = topFailed[0].label;
    const index = keys.indexOf(firstFailed);
    delete keys[index];
    keys.unshift(firstFailed);

    return (
      <Flex
        className="reportContainer"
        mx={isMobile ? 0 : 20}
        mb={40}
        mt={isMobile ? 0 : shiftUp}
        flexDirection="column"
        style={{
          background: '#fff',
          border: '1px solid #eee',
        }}
      >
        <Flex flexDirection="column">
          <Box width={1 / 1}>
            {keys.map(key => {
              const data = criteria[key];
              if (data.length > 0) {
                return <ReportItem data={data} item={key} key={key} />;
              }
            })}
          </Box>
        </Flex>
      </Flex>
    );
  }
}

const mapStateToProps = ({ grade: { criteria, top_failed: topFailed } }) => ({
  criteria,
  topFailed,
});

export default connect(mapStateToProps, null)(Report);
